import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const CreateNewCollaborationAgreement = React.lazy(() => import('./CreateNewCollaborationAgreement'));

const CollaborationAgreementPage: React.FC = () => {
    const drawer = useSelector((state: any) => state.drawer);

    return (
        <Box>
            {drawer?._Key === 'CreateNewCollaborationAgreement' && <CreateNewCollaborationAgreement />}
        </Box>
    )
}

export default CollaborationAgreementPage